import styled, { css } from "styled-components";
import * as colors from "../../settings/colors";

const Label = styled.label`
  display: block;
  font-size: 14px;
  line-height: 19px;
  font-weight: 600;
  margin-bottom: 4px;

  ${({ size }) =>
    size === "large" &&
    css`
      font-size: 15px;
      line-height: 22px;
    `};

  ${({ hasError }) => hasError && css`color: ${colors.RED};`};
`;

export default Label;



// WEBPACK FOOTER //
// ./src/components/forms/Label.js